enum ERoute {
  Login = "/login",
  Logout = "/logout",
  Items = "/items",
  SigninCallback = "/signin-callback",
  SilentRenew = "/silent-renew",
}

export default ERoute;
